<template>
  <CockpitDialog
    class="fixed top-200px left-500px w-800px h-600px"
    v-if="visible"
    :title="'危险有害因素辨识清单'"
    @close="close"
  >
    <div class="w-full h-full relative -mt-10px">
      <div class="w-full h-full relative z-9999">
        <div class="w-full h-48px info-right mt-10px mb-10px">
          <div class="w-full h-full p-2px z-9999 relative">
            <div class="w-full h-full flex justify-start items-center">
              <div
                :class="[
                  'text-[#8fd5db]',
                  'text-16px',
                  'w-80px',
                  'text-center',
                  'cursor-pointer',
                  'mx-10px',
                ]"
                v-for="(item, index) in typeList"
                :key="index"
                @click="handleTypeClick(item)"
              >
                <div :class="[currentIndex === item.code ? 'active-type' : '']">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <equip-list v-if="currentIndex === 1" :areaId="areaId"></equip-list>
        <job-list v-if="currentIndex === 0" :areaId="areaId"></job-list>
      </div>
    </div>
  </CockpitDialog>
</template>

<script>
import EquipList from './components/EquipList'
import JobList from './components/JobList'
import CockpitDialog from '../../../../../components/cockpit/CockpitDialog'

export default {
  name: 'danger-identify-list',
  components: {
    EquipList,
    JobList,
    CockpitDialog,
  },
  props: {
    areaId: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      visible: true,
      currentIndex: 1,
      typeList: [
        {
          code: 1,
          name: '设备设施',
        },
        {
          code: 0,
          name: '作业活动',
        },
      ],
    }
  },
  methods: {
    // 关闭弹窗
    close() {
      this.$emit('cancel')
    },
    handleTypeClick({ code }) {
      this.currentIndex = code
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../../assets/styles/select.scss';
@import '../../../assets/styles/input.scss';
@import '../../../assets/styles/table.scss';
@import '../../../assets/styles/pagination.scss';
@import '../../../assets/styles/shadow.scss';
@import '../../../assets/styles/button.scss';
@import '../../../assets/styles/dialog.scss';

::v-deep .round-button {
  line-height: 1;
}

.active-type {
  position: relative;
  &::before {
    position: absolute;
    content: '';
    bottom: -6px;
    left: 0;
    background: #00ffff;
    width: 100%;
    height: 1px;
  }
  &::after {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    bottom: -5px;
    left: 46%;
    border-bottom: 5px solid #00ffff;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
  }
}
</style>
